export default class Rectangle {
  constructor() {
    this.id = 0;
    this.bounds = [];
    this.style = null;
  }
}